import { DateObject } from '../../reusables/date-object';

/**
 * Blueprint for the reseration details part of ticketing object.
 */
export class TicketingReservationDetails {
  public expiryDate: DateObject;
  public reservationId: string;
  public today: Date = new Date();
  public isDateValid: boolean;

  constructor(data?: any) {
    this.expiryDate = new DateObject(data.expiryDate, 'dd.MM.yyyy');
    this.reservationId = data.reservationId;
    this.today <= this.expiryDate.date ? this.isDateValid = true : this.isDateValid = false;
  }

}
